import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { LoginMode, VerificationType } from 'projects/shared/src/public-api';

@Component({
  selector: 'login-buttons',
  templateUrl: './login-buttons.component.html',
  styleUrls: ['./login-buttons.component.scss']
})
export class LoginButtonsComponent implements OnInit {

  constructor() { }

  @Input() mode: LoginMode;
  @Input() verificationType: VerificationType;

  @Output() clicked: EventEmitter<any> = new EventEmitter();
  @Output() cancelClicked: EventEmitter<any> = new EventEmitter();
  @Output() sendAgainVerificationCode: EventEmitter<VerificationType> = new EventEmitter<VerificationType>();
  @Output() changeViewRequest: EventEmitter<LoginMode> = new EventEmitter<LoginMode>();
  @Output() recoverPassword: EventEmitter<LoginMode> = new EventEmitter<LoginMode>();

  @HostListener('document:keyup.enter', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.click();
  }

  loginMode = LoginMode

  ngOnInit(): void {
  }

  getVerificationLabel(): string {
    switch (this.verificationType) {
      case VerificationType.Mail:
        return 'VERIFICATION.SEND_PHONE';

      case VerificationType.Phone:
        return 'VERIFICATION.SEND_MAIL'

      default:
        return ''
    }
  }

  getLabel() {
    switch (this.mode) {
      case LoginMode.Login:
        return 'LOGIN.LOGIN';

      case LoginMode.New:
        return 'LOGIN.REGISTER';

      case LoginMode.Forgot:
        return 'GENERAL.OK';

      case LoginMode.Verify:
        return 'LOGIN.VERIFICATIN_TITEL';

      case LoginMode.Change:
        return 'LOGIN.CHANGE_PASSWORD';

      default:
        return '';
    }
  }

  showCancel(): boolean {
    switch (this.mode) {
      case LoginMode.Login:
        return false;

      case LoginMode.New:
        return true;

      case LoginMode.Forgot:
        return true;

      case LoginMode.Verify:
        return true;

      case LoginMode.Change:
        return true;
    }
  }

  click() {
    this.clicked.emit(this.mode);
  }

  cancelClick() {
    this.cancelClicked.emit();
  }

  changeView(loginMode: LoginMode) {
    this.changeViewRequest.emit(loginMode);
  }

  sendRecoverPasswordVerification() {
    this.recoverPassword.emit();
  }

  mailOrPhoneSendAgainClicked() {
    let verificationType = this.verificationType == VerificationType.Phone ? VerificationType.Mail : VerificationType.Phone;
    this.sendAgainVerificationCode.emit(verificationType);
  }

  sendAgainClicked() {
    this.sendAgainVerificationCode.emit(this.verificationType);
  }

}
